import { render } from "./CustomMessage.vue?vue&type=template&id=648ddbe0&scoped=true"
import script from "./CustomMessage.vue?vue&type=script&lang=js"
export * from "./CustomMessage.vue?vue&type=script&lang=js"

import "./CustomMessage.vue?vue&type=style&index=0&id=648ddbe0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648ddbe0"]])

export default __exports__